/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentRunsListAgentRuns } from "../../funcs/agentRunsListAgentRuns.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListAgentRunsRequest$inboundSchema,
};

export const tool$agentRunsListAgentRuns: ToolDefinition<typeof args> = {
  name: "agent-runs-list-agent-runs",
  description: `List runs for an agent`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentRunsListAgentRuns(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
